/** @jsxImportSource @emotion/react */

import { useQuery } from '@apollo/client'
import Typography from '@mui/material/Typography'
import { useParams } from 'react-router-dom'
import { findOneVideoCategory, findOneVideoCategoryVariables } from '__generatedTypes__/findOneVideoCategory'
import { cmsRoutes, useLink } from 'routes/cmsRoutes'
import { FIND_ONE_VIDEO_CATEGORY } from 'queries/video'
import { PageLoader } from 'components/PageLoader'

// TODO: this logic should be generalized for edit pages:
//  I want to see generic HOC in the future that accepts a query,
//  shows loader or error state or wrapped component depending on the state

// eslint-disable-next-line react/display-name, @typescript-eslint/no-explicit-any
const withVideoCategoryCheck = (Component: any) => () => {
  const { videoCategoryId = '' } = useParams()
  const { navigate } = useLink()

  const { data, loading } = useQuery<findOneVideoCategory, findOneVideoCategoryVariables>(FIND_ONE_VIDEO_CATEGORY, {
    variables: { findOneVideoCategoryId: videoCategoryId },
    fetchPolicy: 'network-only',
  })

  const videoCategory = data?.findOneVideoCategory

  const redirectToVideoDashboard = () => {
    navigate(cmsRoutes.VIDEO_DASHBOARD, undefined, {
      searchParams: new URLSearchParams({
        subjectId: String(videoCategory?.subject?.id),
        categoryId: String(videoCategory?.id),
      }),
    })
  }

  if (loading) {
    return <PageLoader />
  }

  if (!videoCategory) {
    return <Typography>Video Category not found...</Typography>
  }

  return <Component videoCategory={videoCategory} redirectToVideoDashboard={redirectToVideoDashboard} />
}

export default withVideoCategoryCheck
